import resolvePageModels from '@/utils/resolvers/resolvePageModels';
import { BrPageContext } from '@bloomreach/react-sdk';
import React, { createContext, PropsWithChildren } from 'react';
import { PageModels, RawPageModels } from './PageModels.interface';

export const defaultPageModels: PageModels = {
  config: {},
  labels: {},
  esLabels: {},
  taxonomy: {},
  globalRoundedStyleBlacklist: {},
  ready: false,
  crmReadWhitelist: {},
  httpStatusCode: '',
  language: '',
  langToRedirect: '',
  languages: {},
  contentGroup: '',
  contentGroup2: '',
  contentGroup3: '',
  contentGroup4: '',
  marketoContactInfoPrefill: {},
  datalayerEventBlacklist: [],
  contentCategoryCardDateFieldMapper: {},
  contentCategoryCardDateLabelMapper: {},
  languageConfig: {
    siteLanguage: '',
    alternativeLanguageCodes: {},
  },
};

const PageModelsContext = createContext<PageModels>(defaultPageModels);

export const PageModelsProvider = ({ children }: PropsWithChildren<any>) => {
  const page = React.useContext(BrPageContext);
  const pageModels = React.useMemo(() => resolvePageModels(page), [page]);

  return <PageModelsContext.Provider value={pageModels}>{children}</PageModelsContext.Provider>;
};

export const PreviewPageModelsProvider = ({
  children,
  pageModels,
}: PropsWithChildren<{ pageModels: PageModels }>) => {
  return (
    <PageModelsContext.Provider value={{ ...defaultPageModels, ...pageModels }}>
      {children}
    </PageModelsContext.Provider>
  );
};

export const usePageModels = () => {
  return React.useContext(PageModelsContext);
};
